// extracted by mini-css-extract-plugin
export default {"coachArchive":"StaffArchive_coachArchive__--b+q","name":"StaffArchive_name__T1UAo"};